export enum FieldType {
  Dropdown = "dropdown",
  Text = "text",
  Date = "date",
  Number = "number",
}

export interface OrgFieldConfig {
  id: string
  org_id: string
  field_name: string
  field_type: FieldType
  display_name: string
  display_order: number
  is_active: boolean
  table_contexts: string[]
  created_at: string
  updated_at: string
}

export interface CreateFieldConfigRequest {
  field_name: string
  field_type: FieldType
  display_name: string
  display_order: number
  is_active: boolean
  table_contexts: string[]
  tempOptions?: Array<{id: string, value: string, order: number}>
}

export interface UpdateFieldConfigRequest {
  field_name?: string
  field_type?: FieldType
  display_name?: string
  display_order?: number
  is_active?: boolean
  table_contexts?: string[]
}

